/** 与后端 pay_methods 校验一致：alipay | wechat | paypal | visa | bank */
export const PAY_METHOD_OPTIONS = [
  { value: 'alipay', label: '支付宝' },
  { value: 'wechat', label: '微信' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'visa', label: '信用卡（Visa）' },
  { value: 'bank', label: '银行转账' }
]
